import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Slownik } from '../../models/slownik';
import { SlownikRequest } from '../../models/slowniki-request';
import { SlownikResponse } from '../../models/slownik-response';
import { SlownikRodzaj } from '../../enums/slownik-rodzaj.enum';

@Injectable({
  providedIn: 'root',
})
export class SlownikiApi {
  #httpClient: HttpClient = inject(HttpClient);
  readonly #apiUrl = environment.API_EWNIOSKI + '/slowniki';

  public getSlownik$(
    idSlownika: SlownikRodzaj,
    fraza?: string,
    kod?: string,
  ): Observable<Slownik[]> {
    let httpParams = new HttpParams().set('idSlownika', idSlownika);

    if (fraza) {
      httpParams = httpParams.set('fraza', fraza);
    }

    if (kod) {
      httpParams = httpParams.set('kod', kod);
    }

    return this.#httpClient
      .get<SlownikResponse>(`${environment.API_KREATORY}/slownik/pobierz/get`, {
        params: httpParams,
        withCredentials: true,
      })
      .pipe(map((response: SlownikResponse) => response.elementySlownika));
  }

  public dajListePozycjiSlownika$(
    zadanie: SlownikRequest,
  ): Observable<Slownik[]> {
    return this.#httpClient.post<Slownik[]>(
      `${this.#apiUrl}/dajListePozycjiSlownikaJSON`,
      zadanie,
    );
  }

  public dajElementBy$(zadanie: SlownikRequest): Observable<Slownik> {
    return this.#httpClient.post<Slownik>(
      `${this.#apiUrl}/dajElementByJSON`,
      zadanie,
      { withCredentials: true },
    );
  }

  // public dajKodElementuByNazwa$(zadanie: SlownikRequest): Observable<number> {
  //   return this.#httpClient.post<number>(
  //     `${this.#apiUrl}dajKodElementuByNazwaJSON`,
  //     zadanie,
  //   );
  // }
  //

  //
  // public dajElementyPowiazaneByKod$(
  //   zadanie: SlownikRequest,
  // ): Observable<KodpUdostepnijSlownikZPowiazaniamiTyp> {
  //   return this.#httpClient.post<KodpUdostepnijSlownikZPowiazaniamiTyp>(
  //     `${this.#apiUrl}dajElementyPowiazaneByKodJSON`,
  //     zadanie,
  //   );
  // }
  //
  // public dajPowiatPowiazanyZGminaByKod$(
  //   zadanie: SlownikRequest,
  // ): Observable<ElementSlownikaTyp> {
  //   return this.#httpClient.post<ElementSlownikaTyp>(
  //     `${this.#apiUrl}dajPowiatPowiazanyZGminaByKodJSON`,
  //     zadanie,
  //   );
  // }
  //
  // public dajWojewodztwoPowiazaneZPowiatemByKod$(
  //   zadanie: SlownikRequest,
  // ): Observable<ElementSlownikaTyp> {
  //   return this.#httpClient.post<ElementSlownikaTyp>(
  //     `${this.#apiUrl}dajWojewodztwoPowiazaneZPowiatemByKodJSON`,
  //     zadanie,
  //   );
  // }

  // public dajListePozycjiSlownikaZaOkres$(
  //   zadanie: SlownikRequest,
  // ): Observable<PozycjeSlownika> {
  //   return this.#httpClient.post<PozycjeSlownika>(
  //     `${this.#apiUrl}dajListePozycjiSlownikaZaOkresJSON`,
  //     zadanie,
  //   );
  // }
  //
  // // Zwracanie XML na życzenie (jeśli backend obsługuje!) – tu prawdopodobnie Observable<string> dla XML
  // public dajListePozycjiSlownikaXML$(
  //   zadanie: SlownikRequest,
  // ): Observable<string> {
  //   return this.#httpClient.post<string>(
  //     `${this.#apiUrl}dajListePozycjiSlownikaXML`,
  //     zadanie,
  //     { responseType: 'text' as 'json' },
  //   );
  // }
}
